<div class="form-group">
    <label class="input-label">Calculated default value:</label>
    <select class="form-control"
            name="fieldOptions.calculateValue"
            [(ngModel)]="fieldOptions.calculateValue"
            (ngModelChange)="dataChangedEvent($event)">
    <option value=""></option>
    <option *ngFor="let field of visibleFields" value="value=data['{{field.schema.components[0].key}}'];">
      {{field.schema.components[0].label}} ({{field.blockTitle}})
    </option>
    <option *ngFor="let field of visibleAllFields" value="value=data['{{field.key}}'];">{{field.label}} ({{field.blockTitle}})</option>
    <option *ngFor="let guide of visibleGuides" value="value=data['{{guide.formIoId}}'];">{{guide.title}} (Guide)</option>
    <option *ngFor="let msg of visibleNotifications" value="value=data['{{msg.key}}'];">{{msg.content}} (Notification)</option>
    <option *ngFor="let tag of visibleTags" value="{{tag.name}}">{{tag.name}} (Tag)</option>
    <option *ngIf="fieldOptions.inputType === 'datetime'" value="new Date()">System generated today date</option>
  </select>

</div>